import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('idea', {
      isIdeaFromTemplate: 'isIdeaFromTemplate'
    })
  }
}
